<template>
    <div class="projectListModel">
         <!-- 头部导航公共组件 -->
         <Header :videoHeight="videoHeight" :iseNavigat="isChildeNavigat" :isScroll="isScroll" :isMobile="isMobile"></Header>

         <div :class="['project-menu-box', isProjectMenu ? 'project-menu-fixed' : '']">
            <ul>
                <li @click="handelChageProject('高层建筑')"><strong>High-rise Buildings </strong><span>高层建筑</span></li>
                <li @click="handelChageProject('公共建筑')"><strong>Public Architecture </strong><span>公共建筑</span></li>
                <li @click="handelChageProject('酒店建筑')"><strong>Hotel Architecture </strong><span>酒店建筑</span></li>
                <li @click="handelChageProject('微型建筑')"><strong>Micro Architecture</strong><span>微型建筑</span></li>
            </ul>
            <div style="margin-top: -5px;" :class="['search-box',isMobile ? 'isIpadSearchBox' : '']">
                <el-input placeholder="Search 搜索" v-model="searchContent" class="input-with-select" ref="isFocus" @focus="handleFocus" @blur="handleBlur">
                <el-button slot="prepend" icon="el-icon-search" @click="handleSearchContent"></el-button>
                </el-input>
            </div>
        </div>
         <!-- 主体内容 -->
         <section class="project-content-model">
            
            <el-row :gutter="10" v-if="ProjectList.length">
                <el-col class="product-list-model" :xs="24" :sm="12" :md="6" :lg="6" :xl="6" v-for="(item, index) in ProjectList" :key="index">
                    <div class="project-section" @click="handelDetail(item.proid,item.utype,item.mousefileurl,item.pwdstr,item.tempwdstr,item.uflag,index)" :ref="index === 0 ? 'projectCol' : null">
                        <div class="project-img" :style="{height : projectColHeight + 'px'}" v-if="item.utype != 3 && item.utype != 4">
                            <img class="main-image" :src="item.fileurl" @contextmenu.prevent>
                            <img class="secondary-image" :src="item.mousefileurl" @contextmenu.prevent>

                            <!-- 普通访问 直接展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>

                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>

                            <!-- 受邀访问 点击展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>

                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>
                            <!-- vip是否登录提示 -->
                            <!-- <div :class="['vip-model',isVipShow ? 'vipshowmodel' : '']" v-if="item.uflag == 1">
                                <p style="font-size: 1rem;font-family: 'ahronbd';padding: 24px 0 0px 0;">Permission Denied</p>
                                <p style="font-size: 0.75rem;padding-top: 0;">受限访问</p>
                            </div> -->
                        </div>
                        <div class="project-img-move" :style="{height : projectColHeight + 'px'}" v-else>
                            <img class="main-image" :src="item.fileurl" @contextmenu.prevent>
                            <img class="videoIcomPlay" src="../assets/images/playIcon.png"/>

                            <!-- 普通访问 直接展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>

                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && !ipuserflag && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>

                            <!-- 受邀访问 点击展示密码显示-->
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isPC">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>

                            </div>
                            <div :class="['passwordInpt', isSpanceEnter && spanceIndex == index ? 'passwordInptMobileSpance' : '']" v-if="item.uflag == 2 && ipuserflag && passwordStateIndex === index && isMobile">
                                <el-input size="small" type="password" v-model="item.password" :placeholder="item.placeholderText"  @input="handlePasswordInpt($event,index,item.pwdstr,item.tempwdstr)" maxlength="4"></el-input>
                            </div>

                            <!-- vip是否登录提示 -->
                            <!-- <div :class="['vip-model',isVipShow ? 'vipshowmodel' : '']" v-if="item.uflag == 1">
                                <p style="font-size: 1rem;font-family: 'ahronbd';padding: 24px 0 0px 0;">Permission Denied</p>
                                <p style="font-size: 0.75rem;padding-top: 0;">受限访问</p>
                            </div> -->
                        </div>
                        <div class="project-model-box">
                            <div class="project-name-box">
                                <p>{{ item.introstr }}</p>
                                <h5 :title="item.proname" v-if="item.utype != 3 && item.utype != 4">{{ item.proname }}</h5>
                                <h5 :title="item.proname" v-else style="font-family: Arial;font-size: 1.5rem;font-weight: 500;">{{ item.proname }}</h5>
                            </div>
                            <div :class="['project-time-box', isMobile ? 'mobileProjectTime' : '']">
                                <div :class="[isMobile ? 'mobileTime' : '']" style="margin-bottom: 5px;text-align: right;">{{ item.projectctime }}</div>
                                <div style="display: flex;align-items: center;">
                                    <span style="display: flex;align-items: center;font-weight: 500;width: 100%;justify-content: flex-start;"><img :class="[isMobile ? 'yanMobileSize' : 'yanSize']" src="../assets/images/yan.png"/> <span :class="[isMobile ? 'mobileView' : '']">{{ item.bornum }}</span></span>
                                
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </el-col>
                <!-- <el-col :xs="24" :sm="12" :md="8" :lg="6" :xl="4">
                    <div class="project-section" @click="handelDetail(0)">
                        <div class="project-img">
                        <img class="main-image" src="../assets/images/product_img_1.png">
                        <img class="secondary-image" src="../assets/images/product_img_3.png">
                        </div>
                        <h5>宁波中心</h5>
                        <p>NINGBO CENTRE TOWER</p>
                    </div>
                </el-col> -->
            </el-row>
            <div v-if="isSearchResult == 1">
                <el-empty description="暂无项目内容" :image-size="150" v-if="ProjectList.length <= 0"></el-empty>
            </div>
            <div v-if="isSearchResult == 2">
                <el-empty description=" No related content available 未找到匹配信息" :image-size="150" v-if="ProjectList.length <= 0">
                    <el-button type="primary" size="small" style="background-color: #E0E0E0;color: #333;border: 1px solid #E0E0E0;font-family: 'ahronbd';font-size: 16px;" @click="handleResetContent">Reset Search 重置搜索</el-button>
                </el-empty>
            </div>
            
                
        </section>

        <!-- 视频播放 -->
        <div class="Image-Preview-full-box" v-if="isFullVideo" ref="fullscreenElement">
            <div style="position: fixed;z-index: 999;right: 20px;top: 20px;cursor: pointer;" @click="handelVideoviewClose">
                <img src="../assets/images/close-white.png" />
            </div>
            <video ref="videoFullPlayer" @play="handlePlay" @click="hanldeFullPalayVideo" controls :src="FullVideoUrl" controlslist="nodownload nofullscreen"></video>

            <div style="position: absolute;width: 80px;left: 50%;top: 50%;transform: translate(-50%, -50%);"><img style="width: 100%;" src='../assets/images/playIcon.png' v-if="!isvideoFullPlayer" @click="hanldeFullPalayVideo"></div>
        </div>
        <!-- autoplay -->
         <!-- 尾部导航公共组件 -->
        <Footer></Footer>
        <!-- end -->
    </div>
</template>

<script>
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'

import screenfull from 'screenfull'

import {getItemList,getProjectClassificatList,setPageViewInfo,setSearchContentList} from '@/api/axios-api'

export default {
    name: 'ProjectList',
    components: {
        Header,
        Footer,
        // HelloWorld,
        // loading
    },
    data () {
        return {
            isFullVideo: false,
            isScroll: 3,
            videoHeight: 0,
            isChildeNavigat: true,
            ProjectList: [],
            oldProjectScrollTop: 0,
            isProjectMenu: false,
            isProjectListCache: true,
            projectColHeight: 0,
            FullVideoUrl: '',
            password: '',
            passwordStateIndex: '',
            utypeState: '',
            proid: '',
            mousefileurl: '',
            pwdstr: '',
            tempwdstr: '',
            placeholderText: 'Decode 解码',
            // isEnter: false,
            isSpanceEnter: false,
            OldDindex: '',
            isPC: false,
            isMobile: false,
            systemLanguage: '', // 获取系统语言
            searchContent: '',
            navigat_2: true,
            navigat_3: true,
            navigat_4: true,
            isSearchResult: 1,
            ipuserflag: false, // 判断游客有没有登录
            isVipShow: false,
            isvideoFullPlayer: true,
            spanceIndex: 0
        }
    },
    created () {
        
        // 查看有没有登录
        if (sessionStorage.getItem('isVisited') != null) {
            this.ipuserflag = JSON.parse(sessionStorage.getItem('isVisited'))
            // alert(this.ipuserflag)
        } else {
            this.ipuserflag = false
        }

        sessionStorage.removeItem('projectList')
        sessionStorage.removeItem('isCache')
        sessionStorage.removeItem('videolist')

        sessionStorage.removeItem('RecomListData')
        sessionStorage.removeItem('isRecomListCache')

        sessionStorage.removeItem('aboutPageScroll')

        this.systemLanguage = navigator.language || navigator.userLanguage // navigator.language 更标准，navigator.userLanguage 用于兼容旧浏览器)

    },
    mounted () {
        const userAgent = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|Macintosh|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
        if (userAgent) {
            this.isMobile = true
            } else {
            this.isPC = true
        
        }
        document.body.style.overflow = 'auto'

        this.proidValue = this.$route.query.type
        if (this.$route.query.type == undefined) {

            if (sessionStorage.getItem('isProjectListCache') == null) {
                this.getItemListFun()
            } else {
                
                this.ProjectList = JSON.parse(sessionStorage.getItem('ProjectListData'))
            }
           

        } else {
            window.scrollTo(0, 0)
            if (this.$route.query.type == 1) {

                this.getProjectClassificatListFun('高层建筑')
            } else if (this.$route.query.type == 2) {
                this.getProjectClassificatListFun('公共建筑')
            } else if (this.$route.query.type == 3) {
                this.getProjectClassificatListFun('酒店与地产')
            } else if (this.$route.query.type == 4) {
                this.getProjectClassificatListFun('建筑与研究')
            }
            
        }

        this.$nextTick(() => {
            this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
        })

        // 导航栏隐藏
        // if (window.innerWidth < (630 + 335)) {
        //     this.navigat_2 = false
        // } else {
        //     this.navigat_2 = true
        // }
        // if (window.innerWidth < (930 + 335)) {
        //     this.navigat_3 = false
        // } else {
        //     this.navigat_3 = true
        // }
        // if (window.innerWidth < (1200 + 335)) {
        //     this.navigat_4 = false
        //     // alert('121')
        // } else {
        //     this.navigat_4 = true
        // }

        window.onresize = () => {
            this.$nextTick(() => {
                this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
            })

            // 导航栏隐藏
            // if (window.innerWidth < (630 + 335)) {
            //     this.navigat_2 = false
            // } else {
            //     this.navigat_2 = true
            // }
            // if (window.innerWidth < (930 + 335)) {
            //     this.navigat_3 = false
            // } else {
            //     this.navigat_3 = true
            // }
            // if (window.innerWidth < (1200 + 335)) {
            //     this.navigat_4 = false
            //     // alert('121')
            // } else {
            //     this.navigat_4 = true
            // }
        }

        window.addEventListener('scroll', this.handelScrollProjectMenu) // 项目菜单固定
        // window.addEventListener('keyup', this.setHandleSearchEnter)

        
    },
    beforeDestroy () {
        window.removeEventListener('scroll', this.handelScrollProjectMenu)
        // window.addEventListener('keyup', this.JumpDetails) // 按回车键密码

        // window.removeEventListener('keyup', this.setHandleSearchEnter)
    },
    watch: {
        '$route'() {
            // console.log(this.$route.query)
            // this.getProjectDetailFun(this.$route.query.proid)
            window.scrollTo(0, 0)
            
            if (this.$route.query.type == 1) {
                this.getProjectClassificatListFun('高层建筑')
            } else if (this.$route.query.type == 2) {
                this.getProjectClassificatListFun('公共建筑')
            } else if (this.$route.query.type == 3) {
                this.getProjectClassificatListFun('酒店与地产')
            } else if (this.$route.query.type == 4) {
                this.getProjectClassificatListFun('建筑与研究')
            } else {
                if (sessionStorage.getItem('isProjectListCache') == null) {
                    this.getItemListFun()
                } else {
                    this.ProjectList = JSON.parse(sessionStorage.getItem('ProjectListData'))
                }
                // this.getItemListFun()
            }
        }
    },
    methods: {

        handleFocus () {
            window.addEventListener('keyup', this.setHandleSearchEnter)
        },
        handleBlur () {
            window.removeEventListener('keyup', this.setHandleSearchEnter)
        },

        handlePlay () {
            // sessionStorage.setItem('oldProjectScrollTop',sessionStorage.getItem('oldProjectScrollTop'))
            if (!this.isvideoFullPlayer) {
                screenfull.toggle(this.$refs.fullscreenElement)
            }
            this.isvideoFullPlayer = true

        },

        hanldeFullPalayVideo () {

            if (this.$refs.videoFullPlayer.paused) { // 检查视频是否暂停，如果是则播放
                this.$refs.videoFullPlayer.play()
                this.isvideoFullPlayer = true
                
                screenfull.toggle(this.$refs.fullscreenElement)
                
            } else { // 如果视频正在播放，则暂停（可选）
                this.$refs.videoFullPlayer.pause()
                this.isvideoFullPlayer = false
            }
        
        },

        // 搜索功能
        handleSearchContent () {
            this.isSearchResult = 2
            const parseInfo = {}
            parseInfo.pname = this.searchContent
            setSearchContentList(parseInfo).then(res => {
                if (res.code == 0) {
                // console.log(res)
                // this.projectList = []
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                        
                    }
                    this.ProjectList = res.map.list
                    // this.ProjectList = res.map.list
                    this.passwordStateIndex = ''
                    this.$nextTick(() => {
                      this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
                    })
                }
            })
        },

        
        // 按回车键搜索
        setHandleSearchEnter(event) {
            this.isSearchResult = 2
            if (event.key === 'Enter' || event.keyCode === 13) {
                // console.log('全局回车键被按下');
                const parseInfo = {}
                parseInfo.pname = this.searchContent
                setSearchContentList(parseInfo).then(res => {
                if (res.code == 0) {
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                        
                    }

                    this.ProjectList = res.map.list
                    // this.ProjectList = res.map.list
                    // this.passwordStateIndex = ''
                    this.$nextTick(() => {
                      this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
                    })
                }
                })
                // 添加你的逻辑
            }
        },

        handleResetContent () {
            this.searchContent = ''
            const parseInfo = {}
            parseInfo.pname = this.searchContent
            setSearchContentList(parseInfo).then(res => {
                if (res.code == 0) {
                    // console.log(res)

                    this.$refs.isFocus.focus()
                    this.ProjectList = res.map.list
                    // this.ProjectList = res.map.list
                    // this.passwordStateIndex = ''
                    this.$nextTick(() => {
                      this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
                    })
                }
            })
        },

        // 切换项目导航内容
        handelChageProject(tvalue) {
            this.getProjectClassificatListFun(tvalue)
            window.scrollTo({
                top: 0,
                behavior: 'smooth' // 平滑滚动
            })
            // this.$router.push({ name: 'ProjectList', params: { type: tvalue }})
        },

        getProjectClassificatListFun (tvalue) {
            const parseInfo = {}
            parseInfo.tvalue = tvalue
            getProjectClassificatList(parseInfo).then(res => {
                // console.log(res)
                if (res.code == 0) {
                    this.ProjectList = []
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                        
                    }
                    this.ProjectList = res.map.list
                    this.$nextTick(() => {
                        this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
                    })
                    this.isProjectListCache = false
                    sessionStorage.setItem('isProjectListCache', this.isProjectListCache)
                    sessionStorage.setItem('ProjectListData', JSON.stringify(this.ProjectList))
                }
            })
        },

        // 项目菜单导航固定
        handelScrollProjectMenu () {
        // 
        let scrollProjectTop = window.pageYOffset || document.documentElement.scrollTop

        let scrollProjectStep = scrollProjectTop - this.oldProjectScrollTop
        this.oldProjectScrollTop = scrollProjectTop

        if (scrollProjectTop > 50) {

            if (scrollProjectStep < 0) {
            // 向上滑动
            this.isProjectMenu = true
            // console.log('121')
            } else {
            this.isProjectMenu = false
            }

        } else {
            this.isProjectMenu = false
        }
        // console.log(scrollProjectTop)
        },

        handelDetail (proid,utype,mousefileurl,pwdstr,tempwdstr,uflag,index) {
            // proid
            this.password = ''
            this.isEnter = false
            this.isSpanceEnter = false

            sessionStorage.setItem('oldProjectScrollTop',window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0)

            if (this.OldDindex != index) {
                this.placeholderText = 'Decode 解码'
            }
            this.OldDindex = index

            if (uflag == 1) {
                // 直接访问
                const parseInfo = {}
                parseInfo.proid = proid
                setPageViewInfo(parseInfo).then(res => {
                    console.log(res)
                })
                if (utype == 3 || utype == 4) {

                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.$refs.videoFullPlayer.play();
                        }, 2000); // 2秒后自动播放视频
                    })

                    this.FullVideoUrl = mousefileurl
                    this.isFullVideo = true
                    document.body.style.overflow = 'hidden'
                    // this.toggleFullScreen()

                    screenfull.toggle(this.$refs.fullscreenElement)
                    this.isvideoFullPlayer = true

                    if (screenfull.enabled) {
                    
                    screenfull.on('change', () => {
                        if (!screenfull.isFullscreen) {
                        this.isvideoFullPlayer = false
                        this.$refs.videoFullPlayer.pause()
                        }
                    })
                    } else {
                    alert('全屏API不被支持');
                    }

                    
                    // setTimeout(function)video.play()
                } else {
                    this.$router.push({
                        path: '/projectDetail',
                        query: {proid: proid}
                    })
                }

            } else if (uflag == 2) {
                this.passwordStateIndex = index
                this.proid = proid
                this.pwdstr = pwdstr
                this.tempwdstr = tempwdstr
                this.mousefileurl = mousefileurl
                this.utypeState = utype
                // window.addEventListener('keyup', this.JumpDetails) // 按回车键密码
            }
            // if (uflag == 1) {
            //     if (!this.ipuserflag) {
            //         this.isVipShow = true
            //         setTimeout(() => {
            //             this.isVipShow = false // 延迟显示所有div，可以根据需要调整延迟时间
            //         }, 3000); // 例如，延迟1秒显示所有div
            //     } else {
            //         if (pwdstr == '') {
            //             const parseInfo = {}
            //             parseInfo.proid = proid
            //             setPageViewInfo(parseInfo).then(res => {
            //                 console.log(res)
            //             })
            //             if (utype == 3 || utype == 4) {

            //                 this.$nextTick(() => {
            //                     setTimeout(() => {
            //                         this.$refs.videoFullPlayer.play();
            //                     }, 2000); // 2秒后自动播放视频
            //                 })

            //                 this.FullVideoUrl = mousefileurl
            //                 this.isFullVideo = true
            //                 document.body.style.overflow = 'hidden'
            //                 // this.toggleFullScreen()

            //                 screenfull.toggle(this.$refs.fullscreenElement)
            //                 this.isvideoFullPlayer = true

            //                 if (screenfull.enabled) {
                            
            //                 screenfull.on('change', () => {
            //                     if (!screenfull.isFullscreen) {
            //                     this.isvideoFullPlayer = false
            //                     this.$refs.videoFullPlayer.pause()
            //                     }
            //                 })
            //                 } else {
            //                 alert('全屏API不被支持');
            //                 }

                            
            //                 // setTimeout(function)video.play()
            //             } else {
            //                 this.$router.push({
            //                     path: '/projectDetail',
            //                     query: {proid: proid}
            //                 })
            //             }
            //         } else {
            //             this.passwordStateIndex = index
            //             this.proid = proid
            //             this.pwdstr = pwdstr
            //             this.tempwdstr = tempwdstr
            //             this.mousefileurl = mousefileurl
            //             this.utypeState = utype
            //             window.addEventListener('keyup', this.JumpDetails) // 按回车键密码
            //         }
            //     }
            // } else if (uflag == 2) {
            //     if (pwdstr == '') {
            //         const parseInfo = {}
            //         parseInfo.proid = proid
            //         setPageViewInfo(parseInfo).then(res => {
            //             console.log(res)
            //         })
            //         if (utype == 3 || utype == 4) {

            //             this.$nextTick(() => {
            //                 setTimeout(() => {
            //                     this.$refs.videoFullPlayer.play();
            //                 }, 2000); // 2秒后自动播放视频
            //             })

            //             this.FullVideoUrl = mousefileurl
            //             this.isFullVideo = true
            //             document.body.style.overflow = 'hidden'
            //             // this.toggleFullScreen()

            //             screenfull.toggle(this.$refs.fullscreenElement)
            //             this.isvideoFullPlayer = true

            //             if (screenfull.enabled) {
                        
            //             screenfull.on('change', () => {
            //                 if (!screenfull.isFullscreen) {
            //                 this.isvideoFullPlayer = false
            //                 this.$refs.videoFullPlayer.pause()
            //                 }
            //             })
            //             } else {
            //             alert('全屏API不被支持');
            //             }

                        
            //             // setTimeout(function)video.play()
            //         } else {
            //             this.$router.push({
            //                 path: '/projectDetail',
            //                 query: {proid: proid}
            //             })
            //         }
            //     } else {
            //         this.passwordStateIndex = index
            //         this.proid = proid
            //         this.pwdstr = pwdstr
            //         this.tempwdstr = tempwdstr
            //         this.mousefileurl = mousefileurl
            //         this.utypeState = utype
            //         window.addEventListener('keyup', this.JumpDetails) // 按回车键密码
            //     }
            // }
            
            
            
        },

        JumpDetails(event) {
            if (event.key === 'Enter' || event.keyCode === 13) {
                // alert(this.password)
                // const parseInfo = {}
                // parseInfo.pwdstr = this.password
                // parseInfo.
                // getProjectDetail
                if (this.password == this.pwdstr || this.password == this.tempwdstr) {
                    this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
                    this.password = ''
                    this.placeholderText = 'Decode 解码'
                } else {
                    // this.password = ''
                    // this.isEnter = false
                    // this.isSpanceEnter = false
                    // this.placeholderText = '密码错误'
                    this.ProjectList[this.spanceIndex].password = ''
                    this.ProjectList[this.spanceIndex].placeholderText = '密码错误'
                    this.isSpanceEnter = false

                    setTimeout(() => {
                        this.ProjectList[this.spanceIndex].placeholderText = 'Decode 解码'
                    },1500)
                }
                
                // console.log('全局回车键被按下');
                // this.handleWebsite()
                // 添加你的逻辑
            }
        },

        setJumpDetailsFun (proid,mousefileurl,password) {
            const parseInfo = {}
            parseInfo.proid = proid
            setPageViewInfo(parseInfo).then(res => {
                console.log(res)
            })

             if (this.utypeState == 3 || this.utypeState == 4) {
                this.$nextTick(() => {
                    setTimeout(() => {
                        this.$refs.videoFullPlayer.play();
                    }, 2000); // 2秒后自动播放视频
                })
                this.FullVideoUrl = mousefileurl
                this.isFullVideo = true
                document.body.style.overflow = 'hidden'
                // this.toggleFullScreen()
                screenfull.toggle(this.$refs.fullscreenElement)
                this.isvideoFullPlayer = true

                if (screenfull.enabled) {
                
                screenfull.on('change', () => {
                    if (!screenfull.isFullscreen) {
                    this.isvideoFullPlayer = false
                    this.$refs.videoFullPlayer.pause()
                    }
                })
                } else {
                alert('全屏API不被支持');
                }
            } else {
                this.$router.push({
                    path: '/projectDetail',
                    query: {proid: proid,pwdstr: password}
                })
            }
        },

        // 监听input 输入
        handlePasswordInpt (event,index,pwdstr,tempwdstr) {

            this.password = event
            this.spanceIndex = index

            this.pwdstr = pwdstr
            this.tempwdstr = tempwdstr

            // console.log(this.password)
           
            // const value = event.target.value
            if (this.password === '') {
                this.isSpanceEnter = false
                window.removeEventListener('keyup', this.JumpDetails) // 消除回车键功能
            } else {
                this.isSpanceEnter = true
                window.addEventListener('keyup', this.JumpDetails) // 按回车键监听输入密码跳转详情页
            }

            
            
            // if (event === this.pwdstr || event.toLowerCase() === this.tempwdstr.toLowerCase()) {
            // setTimeout(() => {
            //     this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
            //     this.password = ''
            //     this.placeholderText = ''
            // },100)
            
            // } else if ((event != this.pwdstr || event.toLowerCase() != this.tempwdstr.toLowerCase()) && event.length == 4) {
            //     if (this.systemLanguage == 'zh-CN') {
            //         this.placeholderText = '密码错误'
            //     } else {
            //         this.placeholderText = 'Invalid Password'
            //     }
            //     this.password = ''
            //     this.isSpanceEnter = false

            //     setTimeout(() => {
            //         this.placeholderText = ''
            //     },2000)
            // }
        },

        // handleJumpPasswor () {
        //     if (this.password == this.pwdstr) {
        //         this.setJumpDetailsFun(this.proid,this.mousefileurl,this.password)
        //         this.password = ''
        //         this.placeholderText = 'Decode 解码'
        //     } else {
        //         this.placeholderText = '密码错误'
        //         this.password = ''
        //         this.isEnter = false
        //         this.isSpanceEnter = false
                
        //     }
        // },

        handelVideoviewClose () {
            document.body.style.overflow = 'auto'
            window.scrollTo({
                top: sessionStorage.getItem('oldProjectScrollTop'),
                behavior: 'smooth'
            })
            this.isvideoFullPlayer = true
            this.isFullVideo = false
            this.FullVideoUrl = ''
           
            document.exitFullscreen()
        },

        toggleFullScreen() {

            if (!document.fullscreenElement) {
                document.documentElement.requestFullscreen().catch(err => {
                    alert(`Error attempting to enable full-screen mode: ${err.message} (${err.name})`)
                })
            } else {
                if (document.exitFullscreen) {
                    document.exitFullscreen()
                }
            }
        },

        getItemListFun () {
            const parseInfo = {}
            parseInfo.utype = 1 // 1项目，2新闻
            getItemList(parseInfo).then(res => {
                // console.log(res)
                if (res.code == 0) {
                    for (let i = 0; i < res.map.list.length; i++) {
                        if (res.map.list[i].uflag == 2) {
                            res.map.list[i].password = ''
                            res.map.list[i].placeholderText = 'Decode 解码'
                        }
                        
                    }
                    this.ProjectList = res.map.list
                    this.isProjectListCache = false

                    this.$nextTick(() => {
                        this.projectColHeight = (this.$refs.projectCol[0].offsetWidth * 1) / 2
                    })
                    sessionStorage.setItem('isProjectListCache', this.isProjectListCache)
                    sessionStorage.setItem('ProjectListData', JSON.stringify(this.ProjectList))

                    window.scrollTo({ top: 0});
                }
            })
        }
    }
}
</script>
<style scoped lang="scss">
.projectListModel .project-content-model {
    padding: 40px 30px 2px 30px;
}
.projectListModel .project-content-model .product-list-model {
    // margin-bottom: 2.3rem;
    margin-bottom: 35px;
}
.projectListModel .project-content-model .project-section {
//   margin-bottom: 2.5vw;
//   text-align: center;
  font-family: "SourceHanSans";
  cursor: pointer;
}
.projectListModel .project-img {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}

.projectListModel .project-img .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}

.projectListModel .project-img-move {
  width: 100%;
  height: 210px;
  position: relative;
  overflow: hidden;
}
.projectListModel .project-img-move .main-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
  position: absolute;
  top: 0;
  left: 0;
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}
.projectListModel .videoIcomPlay {
  position: absolute;
  width: 55px;
  left: 50%;
  top: 50%;
  // color: #f7f7f7;
  transform: translate(-50%, -50%);
}

.projectListModel .project-img .secondary-image {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  object-fit: cover;
  opacity: 0; /* 默认隐藏 */
  // transition: opacity 0.5s ease; /* 平滑过渡效果 */
}
.projectListModel .project-img:hover .main-image {
  opacity: 0;
}
.projectListModel .project-img:hover .secondary-image {
  opacity: 1;
}
.projectListModel .project-content-model .project-section h5 {
  font-size: 1.125rem;
  font-weight: 700;
  font-family: "SourceHanSans";
  white-space: break-spaces;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1; /* 限制行数为2 */
  overflow: hidden;
//   white-space: nowrap; /* 防止文本换行 */
//   overflow: hidden; /* 隐藏超出容器的部分 */
//   text-overflow: ellipsis; /* 显示省略号 */
//   padding-bottom: 7px;
}
.projectListModel .project-content-model .project-section p {
//   height: 36px;
//   line-height: 20px;
  font-size: 1.25rem;
  padding: 12px 0 0px 0;
  font-family: "ahronbd";
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
.projectListModel .project-model-box {
  display: flex;
  justify-content: space-between;
  height: 4.375rem;
}
.projectListModel .project-name-box {
  width: 70%;
}
.projectListModel .project-time-box {
  font-size: 0.875rem;
  font-family: Arial;
  padding: 1rem 0 0 0;
  font-weight: 700;
//   width: 72px;
}

// 项目菜单
.projectListModel .project-menu-box {
  border-bottom: 1px solid #262626;
  color: #262626;
  background: #fff;
  z-index: 8;
  width: calc(100% - 60px);
  padding: 120px 0 0 0;
  margin: auto;
  white-space: nowrap;
  display: flex;
  align-items: center;
  justify-content: space-between;
  top:0
}
.projectListModel .project-menu-fixed {
  position: fixed;
  top: 6.125rem;
//   top: 98px;
  transition: top 0.5s ease;
  padding: 0;
  left: 50%;
  transform: translateX(-50%)
}

.projectListModel .project-menu-box ul {
    display: flex;
    padding: 0px 20px 0px 0px;
    overflow: hidden;
    overflow-x: scroll;
}
.projectListModel .project-menu-box ul::-webkit-scrollbar {
  // background: #fff;
  height: 0px;
}
.projectListModel .project-menu-box ul li {
  float: left;
//   margin-right: 20px;
margin-right: 55px;
  padding: 10px 0 15px 0;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.projectListModel .project-menu-box ul li strong {
  font-size: 1.25rem;
  font-family: "ahronbd";
  font-weight: 500;
}
.projectListModel .project-menu-box ul li span {
  font-family: 'SourceHanSansBOLD';
  font-size: 1.125rem;
  padding-left: 4px;
}

.projectListModel .Image-Preview-full-box {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    left: 0;
    background: #000;
    z-index: 999;
}
.projectListModel .Image-Preview-full-box video {
    width: 100%;
    height: 100%;
    // object-fit: cover;
}
.projectListModel::v-deep .passwordInpt {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 150px;
  margin-left: -75px;
  // top: 65%;
  margin-top: -16px;
  background-color: #000;
  border-radius: 16px;
  
}
.projectListModel::v-deep .passwordInpt .el-input__inner {
  background-color: #000;
  border: 1px solid #000;
  border-radius: 17px;
  color: #fff;
  text-align: center;
  font-size: 15px;
  font-family: "SourceHanSans";
//   letter-spacing: 3px;
}
.projectListModel::v-deep .passwordInptSpance .el-input__inner{
    letter-spacing: 5px;
    // font-size: 7px;
    font-size: 25px;
    font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}
.projectListModel::v-deep .passwordInptMobileSpance .el-input__inner{
    letter-spacing: 5px;
    font-size: 10px;
    // font-size: 25px;
    // font-family: '微软雅黑';
    height: 32px;
    line-height: 32px;
}

.projectListModel::v-deep .search-box {
  position: relative;
  width: 19rem;
  height: 2.5rem;
}
.projectListModel::v-deep .search-box .el-input-group {
  height: 100%;
}

.projectListModel::v-deep .search-box .el-input__inner {
  border-top-right-radius: 40px;
  border-bottom-right-radius: 40px;
  border-left: 1px solid #F2F2F2;
  background-color: #F2F2F2;
  font-family: "SourceHanSansBOLD";
  font-size: 1.125rem;
  height: 100%;
  margin-left: -2px;
  padding-left: 1px;
}
.projectListModel::v-deep .search-box .el-input.is-active .el-input__inner, .projectListModel::v-deep .search-box .el-input__inner:focus {
  border-top: 1px solid #DCDFE6;
  border-bottom: 1px solid #DCDFE6;
  border-right: 1px solid #DCDFE6;
  outline: 0;
}
.projectListModel::v-deep .search-box .el-input-group__append, .projectListModel::v-deep .search-box .el-input-group__prepend {
  border-top-left-radius: 40px;
  border-bottom-left-radius: 40px;
  background-color: #F2F2F2;
  padding-right: 10px;
}

.projectListModel::v-deep .search-box .el-icon-search:before {
  color: #000;
  font-size: 1.5625rem;
}
.projectListModel::v-deep .el-icon-search {
  margin-top: 3px;
  margin-left: -9px;
}

.projectListModel .mobileProjectTime {
  padding: 13px 0 0 0;
  // color: RED;
}
.projectListModel .project-time-box .yanSize {
  width: 19px;
  margin-right: 5px;
}
.projectListModel .project-time-box .yanMobileSize {
  width: 14px;
  margin-right: 5px;
}
.projectListModel .project-time-box .mobileTime {
  font-size: 11px;
  // color: red;
}
.projectListModel .project-time-box .mobileView {
  font-size: 12px;
}

.projectListModel .vip-model {
  position: absolute;
  width: 100%;
  height: 100%;
  left: 0;
  bottom: 0;
  transform: translateY(100%); /* 向上移动的距离 */
  background: rgba(0,0,0,0.5);
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  transition: transform 0.5s ease; /* 添加过渡效果 */
  
}
// .CTG-mian-content .vip-model P {
//   font-size: 1rem!important;
// }
.projectListModel .vipshowmodel {
  transform: translateY(0); /* 向上移动的距离 */
}


@media only screen and (min-width: 2048px) {

  .projectListModel .project-menu-box ul li strong {
    font-size: 1.3rem;
  }
  .projectListModel .project-menu-box ul li span {
    font-size: 1.1rem;
  }
}

@media only screen and (min-width: 2560px) {
  .projectListModel .project-menu-box {
    padding: 160px 0 0 0;
  }
  .projectListModel .project-menu-box ul li strong {
    font-size: 1.35rem;
  }
  .projectListModel .project-menu-box ul li span {
    font-size: 1.12rem;
  }
}

@media (min-width: 1536px) and (max-width: 1708px) {
  .projectListModel .project-menu-box ul li strong {
    font-size: 1.25rem;
  }
  .projectListModel .project-menu-box ul li span {
    font-size: 1.08rem;
  }
}

@media (min-width: 1463px) and (max-width: 1536px) {
  .projectListModel .project-menu-box ul li strong {
    font-size: 1.2rem;
  }
  .projectListModel .project-menu-box ul li span {
    font-size: 1.0625rem;
  }
}

@media (min-width: 1360px) and (max-width: 1463px) {
  .projectListModel .project-menu-box ul li {
    // margin-right: 25px;
    margin-right: 52px;
  }
  .projectListModel .project-menu-box ul li strong {
    font-size: 1.2rem;
  }
  .projectListModel .project-menu-box ul li span {
    font-size: 1.0625rem;
  }
}

@media only screen and (max-width: 1280px) {
    .projectListModel .project-menu-box {
        padding: 80px 0 0 0;
    }
    .projectListModel .project-menu-fixed {
        top: 0;
    }
    .projectListModel .project-menu-box ul li {
    // margin-right: 20px;
    margin-right: 25px;
  }
  .projectListModel .project-menu-box ul li span {
    padding-left: 5px;
  }
  .projectListModel .project-menu-box ul li strong {
    font-size: 1.3rem;
  }
  .projectListModel .project-menu-box ul li span {
    font-size: 1rem;
  }
}

// ipad样式
.projectListModel .isIpadSearchBox {
  position: relative;
  width: 20.94rem;
  height: 3rem;
  // background: red;
}
.projectListModel::v-deep .isIpadSearchBox .el-input__inner {
  height: 3rem;
  line-height: 3rem;
  // padding: 2rem 15px;
}
</style>